import React, { useMemo } from 'react'

import { useTimeline } from '@/hooks/useTimeline'

import { HomeIssues } from './HomeIssues/HomeIssues'
import { HomeQualityCheckInspectionDetail } from './Inspections/Details'
import { HomeQualityCheckSummaries } from './Summary/HomeQualityCheckSummaries'

type Props = {
  homeId: number
  homeQualityCheckId?: number
  refetchOnSuccess: () => void
  setHomeQualityCheckId: (homeQualityCheckId?: number) => void
}

export const HomeQualityChecks = ({ homeId, homeQualityCheckId, refetchOnSuccess, setHomeQualityCheckId }: Props) => {
  const { data: homeData, isLoading } = useTimeline({ id: homeId })

  const handleClearHomeQualityCheckId = () => {
    setHomeQualityCheckId(undefined)
    refetchOnSuccess()
  }

  /*
    We're filtering here because we want to display all the Home Issues, even the Resolved ones
    on the Home History.  So we'll fetch all of them once, and then display just the Unresolved ones
    here.
  */
  const homeIssueData = useMemo(() => {
    return homeData && homeData.home?.homeIssues
      ? homeData.home.homeIssues.filter((homeIssue) => !homeIssue.resolvedAt)
      : []
  }, [homeData])

  return (
    <>
      {homeQualityCheckId ? (
        <HomeQualityCheckInspectionDetail
          homeId={homeId}
          homeQualityCheckId={homeQualityCheckId}
          onClearHomeQualityCheckId={handleClearHomeQualityCheckId}
        />
      ) : (
        <>
          {homeData ? (
            <HomeQualityCheckSummaries
              homeData={homeData.home}
              isLoading={isLoading}
              refetchOnSuccess={refetchOnSuccess}
              setHomeQualityCheckId={setHomeQualityCheckId}
            />
          ) : null}

          <HomeIssues data={homeIssueData} isLoading={isLoading} refetchOnSuccess={refetchOnSuccess} />
        </>
      )}
    </>
  )
}
